import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartModule } from 'primeng/chart';
import { ChatChartContent } from '../ai-broker-chat.models';

@Component({
  selector: 'app-chat-chart',
  standalone: true,
  imports: [CommonModule, ChartModule],
  template: `
    <div class="chart-wrapper p-3 surface-card border-round-lg border-1 border-gray-300 my-2">
      <p-chart [type]="chartType()" [data]="chartData()" [options]="data().options"></p-chart>
    </div>
  `,
  styles: [`
    .chart-wrapper {
      width: 100%;
      min-width: 300px;
      background: white;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatChartComponent {
  data = input.required<ChatChartContent>();

  chartType = computed(() => this.data().chartType as "bar" | "line" | "scatter" | "bubble" | "pie" | "doughnut" | "polarArea" | "radar");

  chartData = computed(() => {
    const d = this.data();
    return {
      labels: d.labels,
      datasets: d.datasets
    };
  });
}
